/*! instant.page v5.2.0 - (C) 2019-2023 Alexandre Dieulot - https://instant.page/license */ let _chromiumMajorVersionInUserAgent = null,
  _allowQueryString,
  _allowExternalLinks,
  _useWhitelist,
  _delayOnHover = 65,
  _lastTouchTimestamp,
  _mouseoverTimer,
  _preloadedList = new Set();
const DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION = 1111;
init();
function init() {
  if (!document.createElement('link').relList.supports('prefetch')) return;
  const handleVaryAcceptHeader = 'instantVaryAccept' in document.body.dataset || 'Shopify' in window,
    chromiumUserAgentIndex = navigator.userAgent.indexOf('Chrome/');
  if ((chromiumUserAgentIndex > -1 && (_chromiumMajorVersionInUserAgent = parseInt(navigator.userAgent.substring(chromiumUserAgentIndex + 7))), handleVaryAcceptHeader && _chromiumMajorVersionInUserAgent && _chromiumMajorVersionInUserAgent < 110)) return;
  const mousedownShortcut = 'instantMousedownShortcut' in document.body.dataset;
  (_allowQueryString = 'instantAllowQueryString' in document.body.dataset), (_allowExternalLinks = 'instantAllowExternalLinks' in document.body.dataset), (_useWhitelist = 'instantWhitelist' in document.body.dataset);
  const eventListenersOptions = { capture: !0, passive: !0 };
  let useMousedown = !1,
    useMousedownOnly = !1,
    useViewport = !1;
  if ('instantIntensity' in document.body.dataset) {
    const intensity = document.body.dataset.instantIntensity;
    if (intensity.startsWith('mousedown')) (useMousedown = !0), intensity == 'mousedown-only' && (useMousedownOnly = !0);
    else if (intensity.startsWith('viewport')) {
      const isNavigatorConnectionSaveDataEnabled = navigator.connection && navigator.connection.saveData,
        isNavigatorConnectionLike2g = navigator.connection && navigator.connection.effectiveType && navigator.connection.effectiveType.includes('2g');
      !isNavigatorConnectionSaveDataEnabled && !isNavigatorConnectionLike2g && (intensity == 'viewport' ? document.documentElement.clientWidth * document.documentElement.clientHeight < 45e4 && (useViewport = !0) : intensity == 'viewport-all' && (useViewport = !0));
    } else {
      const milliseconds = parseInt(intensity);
      isNaN(milliseconds) || (_delayOnHover = milliseconds);
    }
  }
  if (
    (useMousedownOnly || document.addEventListener('touchstart', touchstartListener, eventListenersOptions),
    useMousedown ? mousedownShortcut || document.addEventListener('mousedown', mousedownListener, eventListenersOptions) : document.addEventListener('mouseover', mouseoverListener, eventListenersOptions),
    mousedownShortcut && document.addEventListener('mousedown', mousedownShortcutListener, eventListenersOptions),
    useViewport)
  ) {
    let requestIdleCallbackOrFallback = window.requestIdleCallback;
    requestIdleCallbackOrFallback ||
      (requestIdleCallbackOrFallback = (callback) => {
        callback();
      }),
      requestIdleCallbackOrFallback(
        function () {
          const intersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const anchorElement = entry.target;
                intersectionObserver.unobserve(anchorElement), preload(anchorElement.href);
              }
            });
          });
          document.querySelectorAll('a').forEach((anchorElement) => {
            isPreloadable(anchorElement) && intersectionObserver.observe(anchorElement);
          });
        },
        { timeout: 1500 }
      );
  }
}
function touchstartListener(event) {
  _lastTouchTimestamp = performance.now();
  const anchorElement = event.target.closest('a');
  isPreloadable(anchorElement) && preload(anchorElement.href, 'high');
}
function mouseoverListener(event) {
  if (performance.now() - _lastTouchTimestamp < DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION || !('closest' in event.target)) return;
  const anchorElement = event.target.closest('a');
  isPreloadable(anchorElement) &&
    (anchorElement.addEventListener('mouseout', mouseoutListener, { passive: !0 }),
    (_mouseoverTimer = setTimeout(() => {
      preload(anchorElement.href, 'high'), (_mouseoverTimer = void 0);
    }, _delayOnHover)));
}
function mousedownListener(event) {
  const anchorElement = event.target.closest('a');
  isPreloadable(anchorElement) && preload(anchorElement.href, 'high');
}
function mouseoutListener(event) {
  (event.relatedTarget && event.target.closest('a') == event.relatedTarget.closest('a')) || (_mouseoverTimer && (clearTimeout(_mouseoverTimer), (_mouseoverTimer = void 0)));
}
function mousedownShortcutListener(event) {
  if (performance.now() - _lastTouchTimestamp < DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION) return;
  const anchorElement = event.target.closest('a');
  if (event.which > 1 || event.metaKey || event.ctrlKey || !anchorElement) return;
  anchorElement.addEventListener(
    'click',
    function (event2) {
      event2.detail != 1337 && event2.preventDefault();
    },
    { capture: !0, passive: !1, once: !0 }
  );
  const customEvent = new MouseEvent('click', { view: window, bubbles: !0, cancelable: !1, detail: 1337 });
  anchorElement.dispatchEvent(customEvent);
}
function isPreloadable(anchorElement) {
  if (
    !(!anchorElement || !anchorElement.href) &&
    !(_useWhitelist && !('instant' in anchorElement.dataset)) &&
    !(anchorElement.origin != location.origin && (!(_allowExternalLinks || 'instant' in anchorElement.dataset) || !_chromiumMajorVersionInUserAgent)) &&
    ['http:', 'https:'].includes(anchorElement.protocol) &&
    !(anchorElement.protocol == 'http:' && location.protocol == 'https:') &&
    !(!_allowQueryString && anchorElement.search && !('instant' in anchorElement.dataset)) &&
    !(anchorElement.hash && anchorElement.pathname + anchorElement.search == location.pathname + location.search) &&
    !('noInstant' in anchorElement.dataset)
  )
    return !0;
}
function preload(url, fetchPriority = 'auto') {
  if (_preloadedList.has(url) || url.includes('/cart')) return;
  const linkElement = document.createElement('link');
  (linkElement.rel = 'prefetch'), (linkElement.href = url), (linkElement.fetchPriority = fetchPriority), (linkElement.as = 'document'), document.head.appendChild(linkElement), _preloadedList.add(url);
}
//# sourceMappingURL=/cdn/shop/t/110/assets/instant-page.js.map?v=473454186210797571702825445
